import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { PhotoAlbumSlider } from "../../../../../rows/photo-album";

import styles from "./styles.m.css";

const SlideShow = ({ element }) => {
  const type = get(element, ["metadata", "type"]);
  return (
    <PhotoAlbumSlider
      className={styles["gallery-element-slider"]}
      imageElements={element["story-elements"]}
      type={type}
      pagetype="story"
    />
  );
};

SlideShow.propTypes = {
  element: PropTypes.shape({
    "story-elements": PhotoAlbumSlider.propTypes.imageElements,
    metadata: PropTypes.shape({
      type: PropTypes.string
    })
  })
};

export { SlideShow };
